import { george, pr } from "aaa";
import { ChooseEmailResponsive } from "components/common/ChooseEmail";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { GdsFakeActionButtonContainer } from "components/common/GdsFakeActionButtonContainer";
import { InfoBoxWithBackground } from "components/common/InfoBoxWithBackground";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import { FormattedHTMLMessage } from "react-intl";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { IchAppRoutes } from "./IchAppRoutes";
import { IchAppStore } from "./IchAppStore";

type IProps = {
    store: IchAppStore
};

export const IchAppRegistration = observer(({ store }: IProps) => {
    const [waitForRegistration, setWaitForRegistration] = React.useState(false);

    const handleClickContinue = async () => {
        try {
            setWaitForRegistration(true);
            await store.postRegistration();
            pushRoute(IchAppRoutes.EMAIL_VERIFICATION);
        } catch (error) {
            pushRoute("/error");
        } finally {
            setWaitForRegistration(false);
        }
    };

    const handleClickBack = () => {
        pushRoute(IchAppRoutes.ROOT);
    };

    if (store.isLoading) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.Card
            elevated={false}
            style={{ borderRadius: 8 }}
        >
            <div style={{ lineHeight: "24px" }}>
                <div style={{ textAlign: "center", padding: "32px 16px 16px 16px" }}>
                    <pr.IconIchApp style={{ width: 88, height: 64 }} />
                    <pr.P_22_TITLE style={{ fontWeight: 700, lineHeight: "28px", textAlign: "center", marginTop: 8 }}>
                        <FormattedHTMLMessage id="ichApp.landingPage.title" />
                    </pr.P_22_TITLE>
                    <pr.P_16_CONTENT style={{ textAlign: "left", marginTop: 32 }}>
                        {ui.__("ichApp.landingPage.intro")}
                    </pr.P_16_CONTENT>
                </div>
                <div style={{ padding: "16px 16px 32px 16px" }}>
                    <ChooseEmailResponsive contactsStore={store.contactsStore} />
                    <InfoBoxWithBackground style={{ color: ui.isDarkMode ? "white" : undefined, marginTop: 32 }}>
                        {ui.__("ichApp.landingPage.infoBox")}
                    </InfoBoxWithBackground>
                </div>
                <pr.LightSeparatorLine />
                <GdsFakeActionButtonContainer>
                    <GdsFakeActionButton
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                        color="primary"
                        onClick={handleClickContinue}
                        disabled={waitForRegistration || !store.contactsStore.selectedEmailAddress}
                        isLoading={waitForRegistration}
                    >
                        {ui.__("button.continue")}
                    </GdsFakeActionButton>

                    <GdsFakeActionButton
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                        onClick={handleClickBack}
                        disabled={waitForRegistration}
                    >
                        {ui.__("common.back")}
                    </GdsFakeActionButton>
                </GdsFakeActionButtonContainer>
            </div>
        </george.Card>
    );
});



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppRegistration.tsx